import { GeckoInspectionType } from 'types'

export const METHOD_TO_PROCEDURE: Partial<Record<GeckoInspectionType, string>> =
  {
    rug: 'GR2-FOP-011-CM',
  }

export const METHOD_TO_PROCEDURE_TITLE: Partial<
  Record<GeckoInspectionType, string>
> = {
  rug: 'General Rapid Ultrasonic Gridding Using TOKA Robots',
}
